/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_Exporting_LabelInputs */

const en_batch_subtitle_export_exporting_label = /** @type {(inputs: Batch_Subtitle_Export_Exporting_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporting:`)
};

const fr_batch_subtitle_export_exporting_label = /** @type {(inputs: Batch_Subtitle_Export_Exporting_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation :`)
};

const de_batch_subtitle_export_exporting_label = /** @type {(inputs: Batch_Subtitle_Export_Exporting_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportieren:`)
};

const it_batch_subtitle_export_exporting_label = /** @type {(inputs: Batch_Subtitle_Export_Exporting_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione:`)
};

const ru_batch_subtitle_export_exporting_label = /** @type {(inputs: Batch_Subtitle_Export_Exporting_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт:`)
};

const es_batch_subtitle_export_exporting_label = /** @type {(inputs: Batch_Subtitle_Export_Exporting_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportador:`)
};

const zh_cn2_batch_subtitle_export_exporting_label = /** @type {(inputs: Batch_Subtitle_Export_Exporting_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出口：`)
};

const ja_batch_subtitle_export_exporting_label = /** @type {(inputs: Batch_Subtitle_Export_Exporting_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポート:`)
};

const hi_batch_subtitle_export_exporting_label = /** @type {(inputs: Batch_Subtitle_Export_Exporting_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात:`)
};

const pt_pt2_batch_subtitle_export_exporting_label = /** @type {(inputs: Batch_Subtitle_Export_Exporting_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportador:`)
};

/**
* | output |
* | --- |
* | "Exporting:" |
*
* @param {Batch_Subtitle_Export_Exporting_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_exporting_label = /** @type {((inputs?: Batch_Subtitle_Export_Exporting_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_Exporting_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_batch_subtitle_export_exporting_label(inputs)
	if (locale === "de") return de_batch_subtitle_export_exporting_label(inputs)
	if (locale === "it") return it_batch_subtitle_export_exporting_label(inputs)
	if (locale === "ru") return ru_batch_subtitle_export_exporting_label(inputs)
	if (locale === "es") return es_batch_subtitle_export_exporting_label(inputs)
	if (locale === "zh-CN") return zh_cn2_batch_subtitle_export_exporting_label(inputs)
	if (locale === "ja") return ja_batch_subtitle_export_exporting_label(inputs)
	if (locale === "hi") return hi_batch_subtitle_export_exporting_label(inputs)
	if (locale === "pt-PT") return pt_pt2_batch_subtitle_export_exporting_label(inputs)
	return en_batch_subtitle_export_exporting_label(inputs)
});